import React from 'react';
import type { MetricBarPayload } from '../../../data-access/api/science/openapi/api';
import './richContext.scss';

type Props = {
  p: MetricBarPayload;
};

const MetricBarContent: React.FC<Props> = ({ p }) => {
  const min = p.min ?? 0;
  const max = p.max ?? 100;
  const pct = Math.max(0, Math.min(1, (p.value - min) / Math.max(max - min, 1)));
  const fillColor =
    p.color_ramp === 'red_to_green'
      ? `rgba(${Math.round(255 * (1 - pct))},${Math.round(200 * pct)},80,0.9)`
      : p.color_ramp === 'green_to_red'
      ? `rgba(${Math.round(255 * pct)},${Math.round(200 * (1 - pct))},80,0.9)`
      : 'rgba(134,89,255,0.85)';

  return (
    <div className="rc-content-body">
      <div className="rc-metric-header">
        {!!p.label && <span className="rc-content-label">{p.label}</span>}
        <span className="rc-metric-value">
          {p.value} <span className="rc-metric-unit">{p.unit}</span>
        </span>
      </div>
      <div className="rc-bar-track">
        <div
          className="rc-bar-fill"
          style={{ width: `${pct * 100}%`, backgroundColor: fillColor }}
        />
      </div>
    </div>
  );
};

export default MetricBarContent;
